import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FullscreenService {
  private _isFullscreen$ = new BehaviorSubject<boolean>(false);
  isFullscreen$ = this._isFullscreen$.asObservable();

  enterFullscreen(): void {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).webkitRequestFullscreen) {
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) {
      (elem as any).msRequestFullscreen();
    }

    this._isFullscreen$.next(true);
  }

  exitFullscreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }

    this._isFullscreen$.next(false);
  }

  toggle(): void {
    this._isFullscreen$.value ? this.exitFullscreen() : this.enterFullscreen();
  }
}
